const NotFound = () => {
  return <h5>Not found</h5>;
};

export default NotFound;
